import { Component } from '@angular/core';

@Component({
  selector: 'app-lc-route-outlet',
  templateUrl: './lc-route-outlet.component.html',
  styleUrls: ['./lc-route-outlet.component.scss'],
})
export class LcRouteOutletComponent {}
